import { render, staticRenderFns } from "./addLessthanDialog.vue?vue&type=template&id=1bfd9f87&scoped=true&"
import script from "./addLessthanDialog.vue?vue&type=script&lang=js&"
export * from "./addLessthanDialog.vue?vue&type=script&lang=js&"
import style0 from "./addLessthanDialog.vue?vue&type=style&index=0&id=1bfd9f87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd9f87",
  null
  
)

export default component.exports